var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBugfixTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E6570E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 46.0686C27.9853 46.0686 30 44.0539 30 41.5686C30 39.0833 27.9853 37.0686 25.5 37.0686C23.0147 37.0686 21 39.0833 21 41.5686C21 44.0539 23.0147 46.0686 25.5 46.0686Z",
    fill: "#FFB858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.8823C23 30.1941 27.2659 30.1941 27.2659 27.5059C27.2659 24.8176 23 24.8176 23 22.1294C23 19.4411 27.2659 19.4411 27.2659 16.7529C27.2659 14.0647 23 14.0647 23 11.3764C23 8.6882 27.2659 8.68819 27.2659 5.99996",
    stroke: "#FFB858",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugfixTag);
export default __webpack_public_path__ + "static/media/bugfix-tag.ba1e7f18fc206de5c77a2b86de12d279.svg";
export { ForwardRef as ReactComponent };